import type { StateCreator } from 'zustand';
import { Screen } from '@/types';

import { RightPanelTab, type NavigationSlice } from './types';

export type { NavigationSlice } from './types';
export { RightPanelTab } from './types';

export const navigationInitialState = {
  screen: Screen.Library,
  previousScreen: null as Screen | null,
  rightPanelTab: RightPanelTab.Presets,
};

export const createNavigationSlice: StateCreator<
  NavigationSlice,
  [],
  [],
  NavigationSlice
> = (set, get) => ({
  ...navigationInitialState,

  setScreen: (screen) => {
    const currentScreen = get().screen;
    if (currentScreen !== screen) {
      set({ screen, previousScreen: currentScreen });
    }
  },

  setRightPanelTab: (rightPanelTab) => set({ rightPanelTab }),
});
